// vendors
import React from 'react';
import * as Yup from 'yup';
import { Trans } from 'react-i18next';

// constants
import { USER_TYPES } from 'constants/general';

// styles
import { FormTitle } from '../styles/MemberProfileForm';
import { Reinvite } from 'components/settings/Reinvite';

import { UserType } from 'lib/specialPermissions';

export const filterData = (data = [], filterBy = 'id') =>
  Object.values(data).map((item) => item[filterBy]);

export const getValidations = () => ({
  name: Yup.string()
    .trim()
    .min(2, 'Mínimo 2 caracteres!')
    .max(50, 'Máximo 50 caracteres'),
  lastname: Yup.string()
    .trim()
    .min(2, 'Mínimo 2 caracteres!')
    .max(50, 'Máximo 50 caracteres'),
});

export const formFieldValidations = Yup.object().shape(getValidations());

export const buildDefaultValues = (memberData: any) => ({
  ...memberData,
  reinvite: memberData?.email,
  type: USER_TYPES[memberData?.type],
});

export const buildGeneralInfoFormFields = ({
  translate,
  memberData: { confirmed },
  beforeSendReinvite,
}: any) => [
  {
    name: 'name',
    label: translate('common:NAME'),
  },
  {
    name: 'lastname',
    label: translate('common:LAST_NAME'),
  },
  {
    name: 'email',
    label: translate('common:EMAIL_ADDRESS'),
    customField: ({ onChangeField, renderProps }: any) => {
      return (
        <Reinvite
          disabledInput={confirmed}
          fieldName="email"
          beforeSendReinvite={beforeSendReinvite}
          translate={translate}
          onChangeField={onChangeField}
          showReinviteButton={!confirmed}
          {...renderProps}
        />
      );
    },
  },
];

export const buildRoleInfoFormFields = (_t: any = (text: any) => text) => [
  {
    type: 'select',
    name: 'type',
    label: _t('common:ROLE'),
    disabled: true,
    selectData: {
      data: [
        { name: _t('ROLE_TYPES.TEACHER'), id: 1, value: 1 },
        { name: _t('ROLE_TYPES.DIRECTOR'), id: 2, value: 2 },
        { name: _t('ROLE_TYPES.ADMINISTRATOR'), id: 4, value: 4 },
      ],
    },
  },
  {
    limit: '70',
    name: 'role_alias',
    label: _t(
      'settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.PERMISSIONS.LABEL_RENAME_POSITION',
    ),
  },
];

export const buildAssignedClassroomsFormFields = ({ centers }: any) => [
  {
    type: 'select',
    name: 'centers',
    label: <Trans>settings:CENTERS</Trans>,
    selectData: {
      checkbox: true,
      multiple: true,
      data: centers.map(({ id, name }: any) => ({
        id,
        name,
        value: id,
      })),
    },
  },
];

export const buildGeneralInfoFormFieldsSet = ({
  memberData,
  translate,
  centers,
  beforeSendReinvite,
}: any) => {
  const data = {
    generalInfo: {
      fieldsSetTitle: (
        <FormTitle>
          <Trans>
            settings:STAFF_SECTION.MANAGE.EDIT_MEMBER_VIEW.TABS.GENERAL.TITLE
          </Trans>
        </FormTitle>
      ),
      fieldsSetData: buildGeneralInfoFormFields({ translate, memberData, beforeSendReinvite }),
    },
    roleInfo: {
      fieldsSetTitle: (
        <FormTitle>
          <></>
        </FormTitle>
      ),
      fieldsSetData: buildRoleInfoFormFields(translate),
    },
    assignedClassrooms: {},
  };

  if (memberData.type !== UserType.OWNER
    && memberData.type !== UserType.ADMIN) {
    data.assignedClassrooms = {
      fieldsSetTitle: (
        <FormTitle id="assignedClassroomsFormFieldsTitle">
          <Trans>settings:ASSIGNED_CENTERS</Trans>
        </FormTitle>
      ),
      fieldsSetData: buildAssignedClassroomsFormFields({ centers, memberData }),
    };
  }

  return data;
};
